import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  SideNavigation,
  SideNavigationItem,
} from '../../components/SideNavigation';

const FindMenu = React.memo(() => (
  <SideNavigation>
    <SideNavigationItem isDefault to="">
      <FormattedMessage id="find.menu.settings" defaultMessage="Settings" />
    </SideNavigationItem>
    <SideNavigationItem to="images">
      <FormattedMessage id="find.menu.images" defaultMessage="Images" />
    </SideNavigationItem>
  </SideNavigation>
));

export { FindMenu };
